
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/customer-journy-map/done",
      function () {
        return require("private-next-pages/download/customer-journy-map/done/index.tsx");
      }
    ]);
  